 // ARCHIVO AUTO-GENERADO. LOS CAMBIOS SE DESTRUIRÁN.

import {AnualMesIds} from './AnualMes'
import {Tables} from './Tables'
import {Align} from 'sopix/db/db-types'
import {tableColumns} from 'sopix/db/TableColumns'
import {SimpleColumn} from 'sopix/db/dbColumn'

export const AnualMesCol = Object.freeze({
    idMes : new SimpleColumn(AnualMesIds.idMes, 11, 11, Align.RIGHT),
    anoNo : new SimpleColumn(AnualMesIds.anoNo, 11, 11, Align.RIGHT),
})

tableColumns[Tables.AnualMes] = AnualMesCol
